import React from 'react';
import { Col, Container } from 'react-bootstrap';
import Footer from './Footer';
import Header from './Header';
import Sidebar from './Sidebar';

type LayoutProps = {
  children: React.ReactNode;
  isAuthenticated: boolean;
  onLogOut: () => void;
  data: {
    name: string;
    cartCount: number;
  };
};

export default function Layout(props: LayoutProps) {
  const { children, isAuthenticated } = props;
  let content;
  if (isAuthenticated) {
    content = (
      <div className='row'>
        <Col className='d-none d-md-inline-block' md='2'>
          <ul className='cds-nav-primary cds-accordion'>
            <Sidebar />
          </ul>
        </Col>
        <Col md='10'>{children}</Col>
      </div>
    );
  } else {
    content = children;
  }

  return (
    <>
      <Header
        cartCount={props.data.cartCount}
        name={props.data.name}
        isAuthenticated={props.isAuthenticated}
        onLogOut={props.onLogOut}
      />
      <Container className='content'>{content}</Container>
      <Footer />
    </>
  );
}
